var app = angular.module('leonardo');

var WorkOrderService = function(BaseRestService, $q, RestangularProvider) {
  var service = new BaseRestService('work-orders', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('work-orders', false, function(workflow) {
      workflow.addRestangularMethod('complete', 'post', 'mark-as-complete');
      workflow.addRestangularMethod('cancel', 'post', 'mark-as-canceled');
      workflow.addRestangularMethod('setScheduled', 'post', 'mark-as-scheduled');
      workflow.addRestangularMethod('setInProgress', 'post', 'mark-as-in-progress');
      workflow.addRestangularMethod('setPriority', 'post', 'priority');
      workflow.addRestangularMethod('getTriggerData', 'get', 'trigger-data');
      return workflow;
    });
  });

  service.STATUS_CALL = '1';
  service.STATUS_SCHEDULED = '2';
  service.STATUS_IN_PROGRESS = '3';
  service.STATUS_COMPLETED = '4';
  service.STATUS_CANCELED = '5';

  service.TYPE_NORMAL = '0';
  service.TYPE_TRIGGER = '1';

  service.TYPE_OPTIONS = [
    {
      id: service.TYPE_NORMAL,
      name: 'Normal'
    },
    {
      id: service.TYPE_TRIGGER,
      name: 'Trigger'
    },
  ];

  service.TYPE_YARDI = 2;

  service.post = function(params) {
    return RestangularProvider.all('work-orders').customPOST(params, '');
  };

  service.one = function(id){
    var workflow = RestangularProvider.one('work-orders', id);
    workflow.get = function() {
      var defer = $q.defer();
      RestangularProvider.one('work-orders', id).customGET('').then(function(data){
        data.complete = function (params) {
          return RestangularProvider.one('work-orders', id).customPOST(params, 'mark-as-complete');
        };
        data.cancel = function (params) {
          return RestangularProvider.one('work-orders', id).customPOST(params, 'mark-as-canceled');
        };
        data.setScheduled = function (params) {
          return RestangularProvider.one('work-orders', id).customPOST(params, 'mark-as-scheduled');
        };
        data.setInProgress = function (params) {
          return RestangularProvider.one('work-orders', id).customPOST(params, 'mark-as-in-progress');
        };
        data.setPriority = function(params) {
          return RestangularProvider.one('work-orders', id).patch(params);
        };
        data.getTriggerData = function(params) {
          return RestangularProvider.one('work-orders', id).customGET('trigger-data', params);
        };
        defer.resolve(data);
      });
      return defer.promise;
    };
    return workflow;
  };

  service.getReports = function(params) {
    return RestangularProvider.all('work-orders').customGET('report', params);
  };

  service.getActivityReports = function(params) {
    return RestangularProvider.all('work-orders').customGET('report/activity-report', params);
  };


  service.getPlatformFields = function(params) {
    return RestangularProvider.all('work-orders').customGET('pms-platform-fields', params);
  };

  service.getCustomConfigs = function(accountId) {
  return RestangularProvider.all('custom-configs').customGET('', { account_id: accountId });
  };

  service.getPlatformTypes = function(params) {
    return RestangularProvider.all('work-orders').customGET('pms-platform-types', params);
  };

  return service;
};

app.factory('WorkOrderService', ['BaseRestService', '$q', 'Restangular', WorkOrderService]);
